export class DiscountCard{
  id: number
  imgData: string
  imgDataBack: string
  name: string
  barCode: string
}
